// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"d1bb9b76","248":"96e6438d","514":"2e3f3ecc","808":"e72d3321","818":"6bec898c","857":"32ae79cd","865":"94bec3b7","900":"fe1ea0bc","924":"72c829c2","951":"5d1795cc"}[chunkId] + ".chunk.js";
};